<div class="content-rating">
  <div
    #tooltip="ngbTooltip"
    [ngbTooltip]="ratingTooltipTemplate"
    placement="bottom"
    triggers="manual"
    container="body"
    tooltipClass="content-rating_tooltip"
    (mouseenter)="showTooltip(tooltip)"
    (mouseleave)="startHideTimer(tooltip)"
    class="content-rating_item"
  >
    <span>{{ getSafeForWorkText() }}</span>
  </div>
  <div
    *ngIf="subscribed"
    #subscribedTooltip="ngbTooltip"
    [ngbTooltip]="subscribedTooltipTemplate"
    placement="bottom"
    triggers="manual"
    container="body"
    tooltipClass="custom-tooltip"
    (mouseenter)="showTooltip(subscribedTooltip)"
    (mouseleave)="startHideTimer(subscribedTooltip)"
    class="content-rating_item"
  >
    <span>✔️ SUBSCRIBED</span>
  </div>
</div>

<ng-template #ratingTooltipTemplate>
  <div (mouseenter)="cancelHideTimer()" (mouseleave)="hideTooltip()" class="rating-tooltip_content">
    <div class="rating-tooltip_content_header">
      <p class="rating-tooltip_content_header__title">{{ getRatingTooltipTitle() }}</p>
      <p class="rating-tooltip_content_header__description">{{ getRatingTooltipDescription() }}</p>
    </div>
    <div class="rating-tooltip_section">
      <h4 class="rating-tooltip_section__title">Chat style</h4>
      <div class="rating-tooltip_section__list">
        <div
          *ngFor="let chatStyle of getRatingChatStyles(); let i = index"
          class="flex items-center gap-2"
        >
          <stxt-svg-icon
            [iconConfig]="i === 0 ? chatIcon : capitalLetterIcon"
            class="rating-tooltip_item__icon"
          ></stxt-svg-icon>
          <span class="rating-tooltip_item__text">{{ chatStyle }}</span>
        </div>
      </div>
    </div>

    <div class="rating-tooltip_section">
      <h4 class="rating-tooltip_section__title">Images</h4>
      <div class="rating-tooltip_section__list">
        <div
          *ngFor="let imageType of getRatingImageTypes(); let i = index"
          class="flex items-center gap-2"
        >
          <stxt-svg-icon
            [iconConfig]="
              i === 0
                ? ratingType === EContentRatingType.SFW
                  ? eyeSlashIcon
                  : eyeIcon
                : underWearIcon
            "
            class="rating-tooltip_item__icon"
          ></stxt-svg-icon>
          <span class="rating-tooltip_item__text">{{ imageType }}</span>
        </div>
      </div>
    </div>

    <div class="rating-tooltip_footer">
      For more info about generated chat and image content capabilities, go to JustSext's
      <a [href]="ETermsOfService.TermsOfUse" target="_blank" class="terms">Terms of Use</a>
      .
    </div>
  </div>
</ng-template>

<ng-template #subscribedTooltipTemplate>
  <div class="subscribed-tooltip" (mouseenter)="cancelHideTimer()" (mouseleave)="hideTooltip()">
    <p>To manage your subscription, go to 'My Profile'.</p>
  </div>
</ng-template>
